import * as React from "react";

import "./Icon.css";

const SvgLogOutIcon = ({ width, height, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Log_Out_Icon_svg_Layer_1"
    data-name="Layer 1"
    viewBox="0 0 60 60"
    width={width || undefined}
    height={height ? height : "auto"}
    fill="currentColor"
    {...props}
    className={`svg-icon ${props.className || ""}`}
    style={{
      transformOrigin: "center",
      ...props.style,
      ...(width ? { width: width } : {}),
      ...(height ? { height: height } : {}),
    }}
  >
    <defs>
      <style>{".Log_Out_Icon_svg_cls-1{fill:currentColor}"}</style>
    </defs>
    <g transform="translate(6 6)">
      <path
        d="M12.81 0v5.55h29.42v36.9H12.81V48H48V0z"
        className="Log_Out_Icon_svg_cls-1 "
      />
      <path
        d="M34.82 26.69v-5.38H9.2v-6.47L0 24l9.2 9.16v-6.47z"
        className="Log_Out_Icon_svg_cls-1 arrow"
      />
    </g>
  </svg>
);
export default SvgLogOutIcon;
